import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

const SCRIPT_ID = 'bhashini-translation-plugin-script';
const SCRIPT_SRC = 'https://translation-plugin.bhashini.co.in/v3/website_translation_utility.js';
const FEEDBACK_FIELD_COUNT = 2;
const LABEL_RETRY_LIMIT = 5;

@Injectable({
  providedIn: 'root'
})
export class BhashiniService {
  private loaded = false;

  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  loadScript(): void {
    const existingScript = this.document.getElementById(SCRIPT_ID);

    if (this.loaded || existingScript) {
      this.scheduleFeedbackLabeling();
      return;
    }
    this.loaded = true;

    const script = this.document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = SCRIPT_SRC;
    script.setAttribute('page-source-language', 'en');
    script.setAttribute('default-translated-language', 'en');
    script.setAttribute('isReload', 'false');
    script.setAttribute('language-icon-color', '#424242');
    script.addEventListener('load', () => this.scheduleFeedbackLabeling(), { once: true });
    this.document.body.appendChild(script);
  }

  private scheduleFeedbackLabeling(attempt = 0): void {
    if (this.labelFeedbackFields() >= FEEDBACK_FIELD_COUNT || attempt >= LABEL_RETRY_LIMIT) {
      return;
    }

    const view = this.document.defaultView;

    if (view?.requestAnimationFrame) {
      view.requestAnimationFrame(() => this.scheduleFeedbackLabeling(attempt + 1));
    } else {
      setTimeout(() => this.scheduleFeedbackLabeling(attempt + 1), 100);
    }
  }

  private labelFeedbackFields(): number {
    const fields = this.document.querySelectorAll<HTMLTextAreaElement>([
      'textarea.feedback-textarea',
      '.suggested-feedback-container textarea',
      'textarea[placeholder="Describe your issues here..."]',
      'textarea[placeholder="Suggested Feedback"]',
    ].join(', '));

    fields.forEach((field) => {
      const hasAccessibleName = !!field.labels?.length
        || !!field.getAttribute('aria-label')?.trim()
        || !!field.getAttribute('aria-labelledby')?.trim();

      if (hasAccessibleName) {
        return;
      }

      const isSuggestedFeedback = field.matches('.suggested-feedback-container textarea')
        || field.placeholder.toLowerCase().includes('suggested feedback');
      field.setAttribute(
        'aria-label',
        isSuggestedFeedback ? 'Suggested translation feedback' : 'Describe translation issues',
      );
    });

    return fields.length;
  }
}
